import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import AdminToolsMlistAuthStatus from "./AdminToolsMlistAuthStatus";

const Wrap = styled.div`
  width: 100%;
  padding: 24px 16px;
`;

const Title = styled.h1`
  font-size: 22px;
  margin: 0 0 8px 0;
`;

const Subtitle = styled.p`
  margin: 0 0 16px 0;
  color: #555;
`;

const Card = styled.div`
  border: 1px solid #e5e5e5;
  border-radius: 10px;
  padding: 16px;
  background: #fff;
`;

const List = styled.ul`
  margin: 8px 0 0 18px;
`;

export default function AdminToolsLandingPage() {
  return (
    <Wrap>
      <Title>Admin Tools</Title>
      <Subtitle>Internal data-wrangling tools (parity-first).</Subtitle>

      <AdminToolsMlistAuthStatus />

      <Card>
        <div style={{ fontWeight: 700, marginBottom: 8 }}>
          Available tools
        </div>
        <List>
          <li>
            <Link to="/admin-tools/listings">Listings Data Wrangler</Link>
          </li>
          <li>
            <Link to="/admin-tools/hoodies">Hoodie / Profile Data Wrangler</Link>
            {" "}
            <span style={{ color: "#666", fontSize: 12 }}>(read-only)</span>
          </li>
        </List>

        <div style={{ marginTop: 12, color: "#666", fontSize: 13 }}>
          Uses the legacy Django “hoodie” API for listing/profile reads and
          edits. Relationship bridge panels use a separate MList API staff login
          (see banner above). No bulk/destructive actions.
        </div>
      </Card>
    </Wrap>
  );
}

